// Minimal swipe snapping enhancement for mobile-only containers
// Enables loop-like UX by jumping to start/end when reaching edges

const INIT_ATTR = 'data-swipe-on-mobile-init';

function initSwipeContainer(container) {
  if (container.getAttribute(INIT_ATTR)) return;
  container.setAttribute(INIT_ATTR, 'true');

  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;
  let justJumped = false;

  const onEnd = () => {
    if (!isMobile()) return;
    if (justJumped) {
      justJumped = false;
      return;
    }
    const maxScroll = container.scrollWidth - container.clientWidth;
    if (container.scrollLeft <= 0) {
      justJumped = true;
      container.scrollTo({ left: maxScroll, behavior: 'instant' });
    } else if (container.scrollLeft >= maxScroll) {
      justJumped = true;
      container.scrollTo({ left: 0, behavior: 'instant' });
    }
  };

  let debounceId;
  container.addEventListener('scroll', () => {
    clearTimeout(debounceId);
    debounceId = setTimeout(onEnd, 120);
  }, { passive: true });
}

function init() {
  document.querySelectorAll('.group-block-content[data-swipe-on-mobile="true"]').forEach(initSwipeContainer);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

document.addEventListener('shopify:section:load', init);

